import React from 'react'
import { Image } from 'antd';
import BlurredPlaceHolder from '../../assets/images/blurred-placeholder.png'

export default function SingleNft(props) {

    const { image } = props

    return (
        <div>
            <Image
                preview={false}
                src={image}
                className="lazy buy-nft-img"
                placeholder={
                    <Image
                        className="lazy buy-nft-img"
                        preview={false}
                        src={BlurredPlaceHolder}
                    />
                }
            />
        </div>
    )
}